/* global axios */
import ApiClient from './ApiClient';

class TasksAPI extends ApiClient {
  constructor() {
    super('tasks', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  destroy(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  complete(id) {
    return axios.post(`${this.url}/${id}/complete`);
  }

  reopen(id) {
    return axios.post(`${this.url}/${id}/reopen`);
  }

  getForEntity(taskableType, taskableId, params = {}) {
    return axios.get(this.url, {
      params: {
        taskable_type: taskableType,
        taskable_id: taskableId,
        ...params,
      },
    });
  }
}

export default new TasksAPI();
